import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapLocation from '../enums/MapLocation';

type logMapLayerButtonTappedParams = {
  map_location: MapLocation;
};

/**
 * A user taps the ‘layers’ icon from a map view page to bring up the map base layer and overlay selection drawer.
 * @param params - Attributes to log with the amplitude event
 * @param params.map_location - The location of the map where the interaction occurred
 */
const logMapLayerButtonTapped = ({ map_location }: logMapLayerButtonTappedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('map layer button tapped', { 'map location': map_location }, callback);
};

export default logMapLayerButtonTapped;
